/* eslint-disable spaced-comment */
import { combineReducers } from "redux";
import cart from "./addCart/cartSlice";
import auth from './auth/authSlice';
import pos from './pos/posSlice';

const reducers = combineReducers({
  cart,
  auth,
  pos,
});

export default reducers;
